import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './UploadButton.styles';

const UploadButton = ({ onClick, children, type }) => {
  const classes = useStyles();

  return (
    <>
      <input onChange={onClick} accept={type} id="contained-button-file" type="file" className={classes.input} />
      <label htmlFor="contained-button-file">{children}</label>
    </>
  );
};

UploadButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
  type: PropTypes.string,
};

UploadButton.defaultProps = {
  type: '*',
  children: undefined,
};

export default UploadButton;
